export enum GamePhase {
  BET = 'bet',
  TIMEOUT = 'timeout',
  GAME = 'game',
}
